import type { PropsWithChildren } from 'react';
import { CatLayoutContainer } from '@blocks-react/components/LayoutContainer';
import { useBreakpoint } from '../../hooks';
import { PAGE_BREAKPOINTS } from '../../constants/commonConstants';
import { FooterContainer } from './FooterContainer';

export const Footer = ({
  children,
  isCheckout = false,
  withSalesforceChat = false,
  footerDesignUpdate = false
}: PropsWithChildren<{
  isCheckout?: boolean;
  withSalesforceChat?: boolean;
  footerDesignUpdate?: boolean;
}>) => {
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  return (
    <FooterContainer
      isCheckout={isCheckout}
      withSalesforceChat={withSalesforceChat}
      footerDesignUpdate={footerDesignUpdate}
    >
      {isMD ? <CatLayoutContainer>{children}</CatLayoutContainer> : children}
    </FooterContainer>
  );
};
